// extracted by mini-css-extract-plugin
export default {"card":"ExpSection_card__NH8jF","content":"ExpSection_content__JiJra","card-image":"ExpSection_card-image__knmxP","desc":"ExpSection_desc__kMKD6"};